import { MFA_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { UserStatus } from './userStatus';
import { LocalAccount } from './LocalAccount';

export enum DeviceTokenType {
    MOBILE = MFA_TYPES.MOBILE.ID,
    DESKTOP_APP = MFA_TYPES.DESKTOP_APP.ID,
    CHROME = MFA_TYPES.CHROME.ID,
    HARDWARE = MFA_TYPES.HARDWARE.ID,
    OTP = MFA_TYPES.OTP.ID,
    MICROSOFT = MFA_TYPES.MICROSOFT.ID,
    OKTA = MFA_TYPES.OKTA.ID,
    DUO = MFA_TYPES.DUO.ID,
    RSA = MFA_TYPES.RSA.ID,
    PING = MFA_TYPES.PING.ID,
    HYPR = MFA_TYPES.HYPR.ID,
    PING_ADAPTER = MFA_TYPES.PING_ADAPTER.ID,
    AZURE_SSO = MFA_TYPES.AZURE_SSO.ID,
    CUSTOM_MFA = MFA_TYPES.CUSTOM_MFA.ID,
    RADIUS_OTP = MFA_TYPES.RADIUS_OTP.ID,
    MS_TEAMS = MFA_TYPES.MS_TEAMS.ID
}

export enum DeviceTokenStatus {
    ACTIVE = 1,
    EXPIRED = 2
}

export interface DeviceToken {
    id: string;
    isDeleted: boolean;
    isDisabled: boolean;
    status: DeviceTokenStatus;
    userId: string;
    type: DeviceTokenType;
    deviceName: string;
    machineName: string;
    deviceVersion: string;
    lastUsed?: Date;
    createDate: Date;
    timeInterval: number;
    tokenCipher?: string;
}

export interface User {
    guid: string;
    isDeleted: boolean;
    displayName: string;
    userName: string;
    upn?: string;
    domainName: string;
    lastAccess?: Date;
    excludeTill?: Date;
    createDate: Date;
    updateDate: Date;
    tokenLimit: number;
    email: string;
    adEmail?: string;
    isExternalEmail: boolean;
    isManualEmail: boolean;
    isProtected: boolean;
    groups: string[];
    tokens: DeviceToken[];
    status: UserStatus;
    isManuallyRemoved: boolean;
    secondaryUsersCount?: number;
}

export type UserDetails = Omit<User, 'guid'>;

export type UsersBoundLocalAccount = Pick<LocalAccount, 'guid' | 'userName' | 'fullName' | 'accountType' | 'hostname'>;
